import React from 'react'
import { css } from '@emotion/react'
import { Tab, TabPanel } from '../base-ui'


function ProductTab({ items }) {
    const style = css`
        width: 100%;
        .button-group {
            div:first-of-type button, div:last-child button {
                border-radius: 0;
                border-left: 1px solid #ffffff;
            }
        }
    `
    return (
        <div css={style}>
            <Tab tabs={items} hideHeader={items.length < 2}>
                {items.map((item, idx) =>
                    <React.Fragment key={idx}>
                        <TabPanel style='width:100%;'>{item.content}</TabPanel>
                    </React.Fragment>
                )}
            </Tab>
        </div>
    )
}

export default ProductTab